<template>
    <div class="container reportDetail">
        <div class="handle-box">
            <el-tabs v-model="currentTab">
                <el-tab-pane v-for="(report,key,index) in feedbackInfo.feedbackReports" :label="report.reportNo == null?'NEW':report.reportNo" :name="index" :key='index'>
                    <ReportDetail_ReportItem v-model="feedbackInfo.feedbackReports[key]" :feedback="feedbackInfo.feedback" disabled=""></ReportDetail_ReportItem>
                </el-tab-pane>
                <el-tab-pane :label="$t('storeFeedback.report.feedbackDetail')" name="feedbackInfo.feedbackReports.length">
                    <ReportDetail_feedbackDetail v-model="feedbackInfo.feedback" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
	    import reportApi from "@/api/storeFeedback/report";
        import ReportDetail_ReportItem from "@/components/page/storeFeedback/reportQuestionDetail_item";
        import commonFun from "@/utils/commonFun";
        import ReportDetail_feedbackDetail from "@/components/page/storeFeedback/reportDetail_feedbackDetail";

        export default {
            components: {ReportDetail_feedbackDetail, ReportDetail_ReportItem},
            data() {
			    return {
                    isNew:false,
                    nodeList:[],
                    stepsActive:-1,
                    taskApproval:false,
                    operationDeductAccounts:false,
			        feedbackId:null,
                    feedbackReportId:null,
                    feedbackInfo: {
                        feedbackReports: [],
                        feedback:{
                            feedbackFirstCheck:{},
                            feedbackComplaint:{},
                            feedback: {}
                        },
                    },
                    isCopyCreate:false,
                    tabList: [],
                    currentTab: 0,
                    roles:[],
			    }
		    },
            created() {
                let that = this;
                that.roles = JSON.parse(localStorage.getItem("ms_roles"));
                let roles = JSON.parse(localStorage.getItem("ms_roles"));
                let emplFlag = localStorage.getItem('ms_emplFlag');
                //门店      SF_STORE_BASIC
                //反馈中心  SF_FBC_BASIC
                //麦当劳   SF_MCD_BASIC
                //供应商  SF_SUP_BASIC
                for (let i = 0,len=roles.length;i<len;i++){
                    if(roles[i]=='SF_STORE_BASIC'){//门店
                        this.isStore = true;
                    }
                    if(roles[i]=='SF_FBC_BASIC'){//反馈中心
                        this.isFBC = true;
                        this.operationDeductAccounts = true //只有反馈中心可以操作扣账信息
                    }
                    if(roles[i]=='SF_MCD_BASIC'){//麦当劳
                        this.isMCD = true;
                    }
                    
                }
                if(emplFlag == "SUP"){//供应商
                    this.isSUP = true;
                }
                this.getData().then(value => {
                    if (that.feedbackReportId != null) {
                        that.feedbackInfo.feedbackReports.forEach((report, index) => {
                            if (that.feedbackReportId == report.ttFeedbackReportId) {
                                that.currentTab = ""+index;
                            }
                        });
                    }
                })
                if(this.$route.query.debitInfo){//如果从 报告列表 点击 新增扣账信息 进来的
                    this.currentTab = "finalDebitInfo"
                }
                if(this.$route.query.taskApproval){//如果从 任务里 进来的
                    this.taskApproval = true
                }
                if(this.$route.query.action){
                let action = this.$route.query.action;
                    if(action=='create'){
                        this.isNew = true
                    }
                }
                
            },
            methods: {
                getData() {
                    this.feedbackId = this.$route.query.feedbackId;
                    this.feedbackReportId = this.$route.query.feedbackReportId;

                    let action = this.$route.query.action;
                    let that = this;
                    if (action == 'create') {
                        return reportApi.newReportInit(this.feedbackId).then(resp => {
                            that.feedbackInfo = resp.data;
                            that.tabList = [...that.feedbackInfo.feedbackReports,that.feedbackInfo.feedback,that.feedbackInfo.feedbackDebits];
                        });
                    }else {
                        
                        return reportApi.getDetail(this.feedbackId,this.feedbackReportId).then(resp => {
                            that.feedbackInfo = resp.data;

                            if(that.feedbackInfo.feedbackDebits.length>0){
                                //循环数组添加删除用的标示
                                for (let i = 0, len = that.feedbackInfo.feedbackDebits.length; i < len; i++){
                                    that.feedbackInfo.feedbackDebits[i].delIds = i
                                }
                            }
                            if(resp.data.feedback.feedback.debitStatus == 'SUBMIT'){
                                this.operationDeductAccounts = false//提交后不能操作 扣账
                            }
                            let nodeList = resp.data.feedback.nodeList
                            for(let i = 0,len=nodeList.length;i<len;i++){
                                if(nodeList[i].status == 'current'){
                                    this.stepsActive = i;
                                }
                            }
                            this.nodeList = nodeList
                            //获取审批日志的数组
                            let temp = resp.data.feedbackReports
                            let logList = []
                            for (let i = 0,len=temp.length;i<len;i++){
                                if(temp[i].logs.length>0){
                                    for (let j = 0,len=temp[i].logs.length;j<len;j++){
                                        logList.push(temp[i].logs[j])
                                    }
                                    
                                }
                            }
                            that.logList = logList
                            that.tabList = [...that.feedbackInfo.feedbackReports,that.feedbackInfo.feedback,that.feedbackInfo.feedbackDebits];
                        });
                    }
                },
                saveInfo(status){
                    let that = this
                    let list = this.feedbackInfo.feedbackDebits;
                    let data={
                        debitList:list,
                        status:status
                    } 
                    if(list.length>0){
                        for (let i = 0,len=list.length;i<len;i++){
                            if (
                                list[i].debitMonth == null ||
                                list[i].debitMonth == "") {
                                that.$message({ message: "请填写月份", type: "warning" });
                                return;
                            }
                        }
                        reportApi.saveDebitInfo(this.feedbackId,data).then(resp => {
                            if(resp.code==200){
                                if(status=='SUBMIT'){
                                    that.$message({
                                        message: this.$t("common.submitSuccess"),
                                        type: "success"
                                    });
                                    that.operationDeductAccounts = false
                                }else{
                                    that.$message({
                                        message: this.$t("common.saveSuccess"),
                                        type: "success"
                                    });
                                }
                                
                            }
                        });
                    }
                },
                addRow(){
                    let len = this.feedbackInfo.feedbackDebits.length
                    var list = {
                        delIds:len,
                    };
                    this.feedbackInfo.feedbackDebits.push(list);
                },
                delRow(){
                    let that = this;
                    let list = this.feedbackInfo.feedbackDebits;
                    let val = this.$refs.feedbackDebits.selection;
                    if (val.length == 0) {
                        that.$message({ message: "请选择需要删除的数据", type: "warning" });
                    }else{
                        val.forEach(function(item, index) {
                            // 遍历源数据
                            list.forEach(function(itemI, indexI) {
                                if (item.delIds === itemI.delIds) {
                                    list.splice(indexI, 1);
                                }
                            });
                        });
                    }
                    that.feedbackInfo.feedbackDebits = list
                },
                copyCreate(){
                    let that = this;
                    console.log(that.currentTab)
                    if( this.feedbackInfo.feedbackReports[this.currentTab]){
                        let ttFeedbackReportId = this.feedbackInfo.feedbackReports[this.currentTab].ttFeedbackReportId
                        return reportApi.copyCreateFeedbackReport(ttFeedbackReportId).then(resp => {
                            that.feedbackInfo.feedbackReports.push(resp.data) ;
                            // that.tabList = [...that.feedbackInfo.feedbackReports,that.feedbackInfo.feedback,that.feedbackInfo.feedbackDebits];
                        });
                    }
                    
                    
                },
		    },
            watch:{
                '$route.query' (to, from) {
                    this.getData();
                }
            }
	    }

</script>
<style scoped>
.reportDetail .nodeList{
    margin-bottom: 20px;
}
</style>
